import { getNodes } from "../../../../utils/tree";

export function canSelectMultiple(selectedKeysArr, fileMappingsTree) { 
    if (selectedKeysArr.length === 1) {
        return true;
    }
    const mappingIds = [];
    for(let i = 0; i < selectedKeysArr.length; i++) {
        const key = selectedKeysArr[i];
        if (key.startsWith("Mapp_")) {
            mappingIds.push(Number(key.replace("Mapp_", "")));
        } else {
            return false;
        }
    }
   
    const nodes = getNodes(fileMappingsTree, 'children', ({IDMapping}) => mappingIds.includes(IDMapping));
    const idCube = nodes[0].IDCube;
    const idPlugin = nodes[0].PluginId;
    for(let i = 1; i < nodes.length; i++) {
        if ((!nodes[i].XMLFilePath && !nodes[i].PluginId) || (nodes[i].PluginId && nodes[i].SequenceMapping === false) || nodes[i].IDCube !== idCube || ((idPlugin || nodes[i].PluginId) && nodes[i].PluginId !== idPlugin)) {
            return false;
        }
    }
    return true;
}

export function getSelectedNodes(selectedKeys, fileMappingsTree) { 
    const orderedSelectNodes = [];   
    const mappingIds = [];
    for(let i = 0; i < selectedKeys.length; i++) {
        const key = selectedKeys[i];
        mappingIds.push(Number(key.replace("Mapp_", "")));
    }   
    const nodes = getNodes(fileMappingsTree, 'children', ({IDMapping}) => mappingIds.includes(IDMapping));  
    for(let i = 0; i < mappingIds.length; i++) {
        orderedSelectNodes.push(nodes.find(node => node.IDMapping === mappingIds[i]));
    }  
    return orderedSelectNodes;
}

export const initialSequenceMapping = {
    name: "",
    description: ""
}

export function getSequenceMappingMappings(sequenceMapping, fileMappingsTree) { 
    const orderedMappings = [];     
    const mappings = getNodes(fileMappingsTree, 'children', ({IDMapping}) => sequenceMapping.mappingsIDs.includes(IDMapping));  
    for(let i = 0; i < sequenceMapping.mappingsIDs.length; i++) {
        const mapping = mappings.find(m => m.IDMapping === sequenceMapping.mappingsIDs[i]);
        orderedMappings.push(mapping);
    }
    return orderedMappings;
}